/**
 * @generated SignedSource<<beeb6eb5abb0dddd6270d6c8fd8e3f6b>>
 * @relayHash dd3946513cb4a6664dfc08bfd9b0ab23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9aaecc14f5181b304672459af4e7026818b4c4d74d26e40adbbe80c967c46288

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getNumProjectsJPBQuery$variables = {
  cloudId: string;
};
export type getNumProjectsJPBQuery$data = {
  readonly jira: {
    readonly allJiraProjects: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type getNumProjectsJPBQuery = {
  response: getNumProjectsJPBQuery$data;
  variables: getNumProjectsJPBQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "filter",
            "value": {}
          }
        ],
        "concreteType": "JiraProjectConnection",
        "kind": "LinkedField",
        "name": "allJiraProjects",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCount"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getNumProjectsJPBQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getNumProjectsJPBQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9aaecc14f5181b304672459af4e7026818b4c4d74d26e40adbbe80c967c46288",
    "metadata": {},
    "name": "getNumProjectsJPBQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e6cc3e7bbc5fdfe0dcb1b02c4dd70ebb";

export default node;
